export default __webpack_public_path__ + "static/media/expressjs.632d3c32.svg";